// extracted by mini-css-extract-plugin
module.exports = {"hovered":"social-icon_hovered__3pGAK","group":"social-icon_group__208Ki","default":"social-icon_default__368XD","instagram":"social-icon_instagram__1rSxu"};